import { DaoService } from "./../services/dao.service";
import { Component, OnInit, ViewChild } from "@angular/core";
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
  UntypedFormBuilder,
} from "@angular/forms";
import { Router } from "@angular/router";
import { DataSource } from "@angular/cdk/table";
import { LstorageService } from "../services/lstorage.service";
import * as jwtDecode from "jwt-decode";
import { AnalyticsformComponent } from "../admin/analyticsform/analyticsform.component";
import { HeaderComponent } from "../admin/header/header.component";
import { MatPaginator } from "@angular/material/paginator";
import { MatTableDataSource } from "@angular/material/table";
import { MatDialog } from "@angular/material/dialog";

@Component({
  selector: "app-analytics",
  templateUrl: "./analytics.component.html",
  styleUrls: ["./analytics.component.scss"],
})
export class AnalyticsComponent implements OnInit {
  analyticsList: any;
  private paginator: MatPaginator;
  dataSource: any;
  public created_By: any;
  singledata: any;

  public analyticsEdit = {
    edit: false,
  };
  public shown = {
    grid: true,
    Form: false,
  };
  public validator = {
    errorMessage: "",
    UniqueEntity: false,
  };

  types: string[] = ["Entity analysis", "General"];
  entity: string[] = ["People", "Company", "Content", "Website"];

  displayedcolumns: string[] = ["Sno", "name", "powerBIURL", "edit", "delete"];
  Analytics = new FormGroup({
    analyticsId: new FormControl(),
    name: new FormControl(),
    powerBIURL: new FormControl(),
    type: new FormControl(),
    entities: new FormControl(),
    isActive: new FormControl(),
    createdBy: new FormControl(),
    createdOn: new FormControl(),
    modifiedBy: new FormControl(),
    modifiedOn: new FormControl(),
  });

  @ViewChild(MatPaginator, { static: false }) set matPaginator(
    mp: MatPaginator
  ) {
    this.paginator = mp;
    // this.setDataSourceEntity();
  }

  constructor(
    private daoService: DaoService,
    private fb: UntypedFormBuilder,
    private router: Router,
    public dialog: MatDialog,
    private token: LstorageService
  ) {}

  ngOnInit() {
    this.daoService.getAnalyticsList().subscribe(
      (data: any) => {
        // this.analyticsList = data;
        this.daoService.defaultAnalyticsList(data);
        this.daoService.finalAnalyticsList.subscribe(
          (analyticsList) => (this.analyticsList = analyticsList)
        );

        this.dataSource = new MatTableDataSource(this.analyticsList);
        this.dataSource.paginator = this.paginator;
        console.log(this.dataSource);
      },
      (error) => {
        console.log("Error:" + error);
      }
    );

    this.created_By = jwtDecode(this.token.getToken());
    this.Analytics = this.fb.group({
      analyticsId: [""],
      name: ["", [Validators.required]],
      powerBIURL: ["", [Validators.required]],
      type: [""],
      entities: this.fb.array([]),
      isActive: ["true"],
      createdBy: [this.created_By.unique_name],
      createdOn: ["2020-01-03T15:50:10.213Z"],
      modifiedBy: [""],
      modifiedOn: ["2020-01-03T15:50:10.213Z"],
    });
    //

    // this.analyticsList=this.analyticsList.concat(this.singledata);
  }

  public analyticsFilter = (value: string) => {
    this.dataSource.filter = value.trim().toLocaleLowerCase();
  };

  setdatasourceAnalytics() {
    this.setdatasourceAnalytics();
    this.dataSource.paginator = this.paginator;
  }
  AnalyticsForm() {
    this.analyticsEdit.edit = false;
    this.shown.grid = false;
    this.shown.Form = true;
    this.Analytics = this.fb.group({
      analyticsId: [""],
      name: ["", [Validators.required]],
      powerBIURL: ["", [Validators.required]],
      type: [""],
      entities: [""],
      isActive: ["true"],
      createdBy: [this.created_By.unique_name],
      createdOn: ["2020-01-03T15:50:10.213Z"],
      modifiedBy: [""],
      modifiedOn: ["2020-01-03T15:50:10.213Z"],
    });
  }
  createAnalytics() {
    this.validator.UniqueEntity = false;
    console.log("create analytics");
    console.log(this.Analytics.value);
    this.daoService
      .AddAnalytics(this.Analytics.value)
      .subscribe((data: any) => {
        this.backanalyticsList();
      });

    (error) => {
      this.validator.UniqueEntity = true;
      this.validator.errorMessage = error.error.userMessage;
    };
  }
  editAnalytics(id) {
    this.token.saveAnalyticsFormId(id);
    const dialogRef = this.dialog.open(AnalyticsformComponent, {
      disableClose: true,
      panelClass: "custom-dialog-container",
      width: "400px",
      height: "80%",
      autoFocus: false,
    });
    dialogRef.beforeClosed().subscribe((analyticsList) => {
      this.dataSource = new MatTableDataSource(this.analyticsList);
      this.dataSource.paginator = this.paginator;
    });
  }

  deleteAnalytics(id) {
    this.daoService.deleteAnalyticsById(id).subscribe((data: any) => {
      this.analyticsList = this.removeFromArrayOfHash(
        this.analyticsList,
        "analyticsId",
        data.data.analyticsId
      );
      this.dataSource = new MatTableDataSource(this.analyticsList);
      this.dataSource.paginator = this.paginator;
    });
  }

  removeFromArrayOfHash(p_array_of_hash, p_key, p_value_to_remove) {
    return p_array_of_hash.filter((l_cur_row) => {
      return l_cur_row[p_key] != p_value_to_remove;
    });
  }

  backanalyticsList() {
    this.shown.grid = true;
    this.shown.Form = false;
    this.validator.UniqueEntity = false;
    this.daoService.getAnalyticsList().subscribe(
      (data: any) => {
        this.analyticsList = data;
        this.dataSource = new MatTableDataSource(this.analyticsList);
        this.dataSource.paginator = this.paginator;
      },
      (error) => {
        console.log("Error: " + error);
      }
    );
  }
  openDialog(): void {
    this.token.clearanalyticsformId();
    const dialogRef = this.dialog.open(AnalyticsformComponent, {
      disableClose: true,
      panelClass: "custom-dialog-container",
      width: "562px",
      height: "544px",
      autoFocus: true,
    });
    dialogRef.beforeClosed().subscribe((analyticsList) => {
      this.dataSource = new MatTableDataSource(this.analyticsList);
      this.dataSource.paginator = this.paginator;
    });
  }
}
